module.exports = __webpack_public_path__ + "img/red-triangle-left.80158ac.png";